/**
 *
 * Asynchronously loads the component for Support
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
